
<template>
  <div>
    <v-row v-for="(di, idx) in items " :key="idx + 'card'">
      <v-col cols='12'>
        <div class="my-2" style="border: solid 1px #ddd; border-radius:12px">
          <v-row align='center' class="px-1 py-2">
            <v-col grow>
              <v-row class="pa-3" align='center' justify="start">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" text icon outlined small
                      :color="di.status == 'won' ? 'success' : di.status == 'lost' ? 'error' : 'primary'">
                      <v-icon small v-if="di.status != 'open'">{{
                        di.status == 'won' ? 'mdi-thumb-up' :
                          'mdi-thumb-down'
                      }}</v-icon>
                      <span v-if="di.status == 'open'">{{ idx+ 1}}</span>
                    </v-btn>
                  </template>
                  Item {{ idx+ 1}}
                </v-tooltip>
                <div class="subheader mb-0 ml-1"> {{ di.brand_product_name }} </div>
              </v-row>
              <v-row align='center' justify="space-around" class=" pa-3 mt-0">
                <!-- text or icon are good to 1.5, fab or text are good to 2.0 -->
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on }">
                    <v-chip v-on="on" small outlined text-color="primary ma-1">
                      <v-avatar>
                        <v-icon>mdi-check</v-icon>
                      </v-avatar>
                      {{ di.total_bags }} sacos
                    </v-chip>
                  </template>
                  Quantidade negociada
                </v-tooltip>
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on }">
                    <v-chip v-on="on" small outlined text-color="primary ma-1">
                      <v-avatar>
                        <v-icon> mdi-currency-usd</v-icon>
                      </v-avatar>
                      {{ Number(di.sell_price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                    </v-chip>
                  </template>
                  Nosso preço
                </v-tooltip>
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on }">
                    <v-chip v-on="on" small outlined text-color="primary ma-1">
                      <v-avatar>
                        <v-icon> mdi-cash</v-icon>
                      </v-avatar>
                      {{ Number(di.other_sell_price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                    </v-chip>
                  </template>
                  Média concorrência
                </v-tooltip>
              </v-row>

            </v-col>
            <v-col cols='10' sm='2' text-xs-right v-if="show_crud_item">
              <v-row class="pa-2" justify="end" align='center'>
                <v-btn text icon color="primary" @click="editItem(idx)"><v-icon small>mdi-pencil</v-icon></v-btn>
                <v-btn text icon color="error" @click="removeDealItem(idx)"><v-icon small>mdi-delete</v-icon></v-btn>

              </v-row>
            </v-col>
            <v-col cols='10' sm='2' text-xs-right v-if="is_winning">
              <v-row justify="end" align='center'>
                <v-btn :text="di.status != 'won'" icon :color="di.status == 'won' ? 'success' : 'grey'"
                  @click="di.status = 'won'"><v-icon small>mdi-thumb-up</v-icon></v-btn>
                <v-btn :text="di.status != 'lost'" icon :color="di.status == 'lost' ? 'error' : 'grey'"
                  @click="di.status = 'lost'"><v-icon small>mdi-thumb-down</v-icon></v-btn>

              </v-row>
            </v-col>

          </v-row>

        </div>

      </v-col>

      <v-card v-if="false" text style="border-radius:12px; border: solid 1px #bbb">
        <v-card-title primary-title class="pb-0 pt-2">
          <div class="subheading">Item {{ idx+ 1}}</div>
        </v-card-title>
        <v-card-text class="pa-1">
          <v-row align-end>
            <v-col cols='11'>
              <v-row>
                <v-col cols='6'>
                  <v-text-field readonly :value="di.brand_product_name" prepend-icon="mdi-magnify"
                    label="Marca - Produto"></v-text-field>
                </v-col>
                <v-col cols='3'>
                  <v-text-field readonly :value="di.sell_price" prepend-icon="mdi-magnify" prefix="R$"
                    label="Nosso preço"></v-text-field>
                </v-col>
                <v-col cols='3'>
                  <v-text-field readonly :value="di.other_sell_price" prepend-icon="mdi-magnify" prefix="R$"
                    label="Concorrente"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols='10'>
                  <v-row>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols='1' text-xs-right>
              <v-btn text icon color="primary" @click="editItem(idx)"><v-icon small>mdi-pencil</v-icon></v-btn>
              <v-btn text icon color="error" @click="removeDealItem(idx)"><v-icon small>mdi-delete</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>

    <v-dialog v-model="dialog_one_item" v-if="dialog_one_item" max-width="500px" transition="dialog-transition">
      <edit-item :one_item="one_item" :setItem="setItem" :unsetItem="unsetItem"></edit-item>
    </v-dialog>

    <v-row v-if="show_crud_item">
      <v-btn block text color="primary" @click="addDealItem()"><v-icon left>mdi-plus-thick</v-icon> item</v-btn>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  components: {
    EditItem: () => import('./editItem.vue'),
  },
  props: {
    show_crud_item: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
    },
    is_winning: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      key: null,
      one_item: {},
      dialog_one_item: false,

      default_deal_item: {
        brand_id: null,
        brand_name: '',
        pickup_location_id: null,
        product_pickup_location_id: null,
        product_pickup_location_name: '',
        product_id: null,
        brand_product_name: '---',
        sell_price: '0.00',
        other_sell_price: '0.00',
        total_bags: 0,
        status: 'open',
      },
    }
  },
  methods: {
    compileProduct(item) {
      return `${item.brand_name} - ${item.product_pickup_location_name}`
    },
    addDealItem() {
      this.items.push({ ...this.default_deal_item })
    },
    removeDealItem(idx) {
      let deleted_item = this.items.splice(idx, 1)
      if (deleted_item[0].id) {
        let c = confirm("Deseja deletar esse item?")
        if (c) {
          Api.DealItem.delete(deleted_item[0].id)
        }
      }
    },
    editItem(idx) {
      this.one_item = { ...this.items[idx], idx }
      this.dialog_one_item = true
    },
    setItem() {
      let { idx, ...obj } = this.one_item
      this.items[idx] = { ...obj }
      this.one_item = {}
      this.dialog_one_item = false
    },
    unsetItem() {
      this.one_item = {}
      this.dialog_one_item = false
    },

  },

}
</script>
